export const SEND_VERIFY_EMAIL_ALERT_RECIPIENT = 'SEND_VERIFY_EMAIL_ALERT_RECIPIENT'

export const VERIFY_EMAIL_ALERT_RECIPIENT_INVALID_TOKEN = 'VERIFY_EMAIL_ALERT_RECIPIENT_INVALID_TOKEN'

export const SET_MESSAGE_VERIFY_EMAIL_ALERT_RECIPIENT = 'SET_MESSAGE_VERIFY_EMAIL_ALERT_RECIPIENT'



// WEBPACK FOOTER //
// ./app/actions/verifyEmailAlertRecipient/constants.js